import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/app/inbox/unresolved')({
  beforeLoad: () => {
    throw redirect({ to: '/app/conversations', replace: true });
  },
});
